import { create } from 'zustand';

interface PatentMapStore {
  // Pending molecule ID to scroll to in grid when switching back
  pendingScrollMoleculeId: number | null;
  setPendingScrollMoleculeId: (id: number | null) => void;
  clearPendingScroll: () => void;
}

export const usePatentMapStore = create<PatentMapStore>((set) => ({
  pendingScrollMoleculeId: null,
  setPendingScrollMoleculeId: (id) => set({ pendingScrollMoleculeId: id }),
  clearPendingScroll: () => set({ pendingScrollMoleculeId: null }),
}));
